<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 299.99998 299.99998"><g transform="matrix(4.276095 0 0 -4.276091 -575.40222 358.00074)" style="fill:#cec7c4;stroke-miterlimit:2.613126;stroke:#564a4c;fill-rule:evenodd;stroke-width:1.4998"><path d="m 176.4941,67.7117 c -1.8641,0 -4.0172,-1.3646 -5.1871,-2.7269 -0.8164,-0.9504 -1.6934,-2.48 -1.7084,-5.2347 2.2328,-0.2597 4.1774,1.0584 5.4286,2.9361 0.9938,1.4919 1.5508,3.3372 1.4669,5.0255 z"/><path d="m 182.7133 42.2507 c -4.2667 2.1461 -4.763 9.2163 -.7662 12.5779 c 1.6676 1.4037 -1.2971 2.8573 -2.6345 3.3936 c -2.9843 1.1971 -4.8053 .6228 -7.5793 -.4113 c -.8359 -.3118 -1.5485 -.6951 -2.5429 -.451 c -2.3675 .5803 -3.8861 2.1872 -7.5042 .9882 c -9.631 -3.191 -6.2929 -18.4595 -.3903 -24.0537 l .8382 -.7328 c 3.4259 -2.7272 5.4368 1.5622 9.9297 .2554 c .8113 -.2358 1.4814 -.6431 2.2627 -.8776 c 3.8443 -1.1537 7.6955 3.8642 8.9478 7.3769 c .5811 1.6302 .5964 1.3516 -.561 1.9344 z"/></g></svg>
</template>


<script>
  export default {
    props: {
      width: {
        type: [Number, String],
        default: 300
      },
      height: {
        type: [Number, String],
        default: 300
      }
    }
  }
</script>